// Central, editable site configuration for Yogarambh Wellness.
// Update contact details, social links and brand copy here.

export const siteConfig = {
  name: "Yogarambh Wellness",
  shortName: "Yogarambh",
  tagline: "Yoga with Suman Agrawal",
  subTagline: "Yoga & Wellness",
  mission:
    "India is known for its soft power and yoga is the foundation of it. I wish to spread this knowledge of health and wellness to as many people as possible.",

  // Contact
  phoneDisplay: "+852 6844 1927",
  phoneE164: "85268441927",
  email: "sumanagrawall123@gmail.com",
  headquarters: "Hong Kong",

  // Social
  instagramHandle: "yoga_with_sumanag",
  instagramUrl: "https://www.instagram.com/yoga_with_sumanag",

  // WhatsApp (same number as contact)
  whatsappUrl:
    "https://wa.me/85268441927?text=Hi%20Suman%2C%20I'd%20like%20to%20know%20more%20about%20your%20yoga%20classes",
};

export default siteConfig;
